"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var utils_1 = require("@qwilr/kaleidoscope/utils");
var react_1 = __importStar(require("react"));
var Telemetry_1 = require("@CommonFrontend/Public/Telemetry/Telemetry");
var TelemetryEnums_1 = require("@CommonFrontend/Telemetry/TelemetryEnums");
var Telemetry_2 = require("Telemetry");
var react_dom_1 = __importDefault(require("react-dom"));
var CollaboratorInviteForm_1 = __importDefault(require("./CollaboratorInviteForm"));
var ConfirmRequestModal_1 = __importDefault(require("./ConfirmRequestModal"));
var CollaboratorCommentModal_1 = __importDefault(require("./CollaboratorCommentModal"));
var snakeCase_1 = __importDefault(require("lodash/snakeCase"));
function fireOnClickTelemetry(telemetry, eventName) {
    var _a;
    telemetry.track(eventName, (_a = {},
        _a["".concat((0, snakeCase_1.default)(eventName), "_source")] = TelemetryEnums_1.TelemetrySource.CollaboratorPage,
        _a), { includeAuthAttrs: true });
}
var CollaboratorCommentPopup = function (_a) {
    var _b, _c;
    var publicApiBaseUrl = _a.publicApiBaseUrl;
    var telemetry = Telemetry_1.Telemetry.getInstance();
    var _d = __read((0, react_1.useState)(false), 2), showTooltip = _d[0], setShowTooltip = _d[1];
    var _e = __read((0, react_1.useState)(null), 2), tooltipPosition = _e[0], setTooltipPosition = _e[1];
    var _f = __read((0, react_1.useState)(false), 2), commentModalVisible = _f[0], setCommentModalVisible = _f[1];
    var _g = __read((0, react_1.useState)(false), 2), confirmModalVisible = _g[0], setConfirmModalVisible = _g[1];
    var _h = __read((0, react_1.useState)(false), 2), formModalVisible = _h[0], setFormModalVisible = _h[1];
    var onHighlight = (0, react_1.useCallback)(function () {
        var isAuth = telemetry.getIsAuth();
        if (isAuth) {
            setShowTooltip(false);
        }
        else {
            setShowTooltip(true);
        }
    }, []);
    (0, react_1.useEffect)(function () {
        var handler = function () {
            var text = document.getSelection().toString();
            if (text.length > 0) {
                onHighlight();
                var selection = document.getSelection();
                var range = selection.getRangeAt(0);
                var rect = range.getBoundingClientRect();
                var x = rect.x + rect.width / 2 - 78;
                if (window.scrollY === 0) {
                    var y = rect.top - 75;
                    setTooltipPosition({ x: x, y: y });
                }
                else {
                    var y = rect.top - 75 + window.scrollY;
                    setTooltipPosition({ x: x, y: y });
                }
            }
            else {
                setShowTooltip(false);
                setTooltipPosition(null);
            }
        };
        $(window).resize(function () {
            setShowTooltip(false);
            setTooltipPosition(null);
        });
        document.addEventListener("selectionchange", handler);
        return function () {
            document.removeEventListener("selectionchange", handler);
        };
    }, []);
    var portalRoot = (0, utils_1.getPortalRoot)("tooltip");
    if (!portalRoot)
        return null;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_dom_1.default.createPortal(react_1.default.createElement(react_1.default.Fragment, null, showTooltip && (react_1.default.createElement("div", { style: {
                position: "absolute",
                top: (_b = tooltipPosition === null || tooltipPosition === void 0 ? void 0 : tooltipPosition.y) !== null && _b !== void 0 ? _b : 0,
                left: (_c = tooltipPosition === null || tooltipPosition === void 0 ? void 0 : tooltipPosition.x) !== null && _c !== void 0 ? _c : 0,
                zIndex: 2,
            } },
            react_1.default.createElement(kaleidoscope_1.Toolbar, { positionType: kaleidoscope_1.ToolbarPositionType.None, visible: true },
                react_1.default.createElement(kaleidoscope_1.Button, { type: kaleidoscope_1.ButtonType.Tertiary, onClick: function () {
                        fireOnClickTelemetry(telemetry, Telemetry_2.TelemetryEventName.CollaboratorCommentWidgetClicked);
                        setCommentModalVisible(true);
                    } },
                    react_1.default.createElement(icons_1.AddComment, null),
                    "Comment"))))), portalRoot),
        commentModalVisible && (react_1.default.createElement(CollaboratorCommentModal_1.default, { closeModal: function () { return setCommentModalVisible(false); }, openFormModal: function () {
                setFormModalVisible(true);
                setCommentModalVisible(false);
            } })),
        formModalVisible && (react_1.default.createElement(CollaboratorInviteForm_1.default, { openConfirmModal: function () {
                setFormModalVisible(false);
                setConfirmModalVisible(true);
            }, closeAllModal: function () {
                setFormModalVisible(false);
                setConfirmModalVisible(false);
            }, backCommentModal: function () {
                setFormModalVisible(false);
                setCommentModalVisible(true);
            }, publicApiBaseUrl: publicApiBaseUrl })),
        confirmModalVisible && react_1.default.createElement(ConfirmRequestModal_1.default, { closeModal: function () { return setConfirmModalVisible(false); } })));
};
exports.default = CollaboratorCommentPopup;
